export default __webpack_public_path__ + "static/media/danishgot-screenshot-04.603b05ff.png";